import { selectTradingWallet } from "@/entities/trading"
import { useAppSelector } from "@/shared/lib/redux"
import { useMemo } from "react"
import { EarnButton } from "../earn-button"
import { selectBonuses } from "@/entities/bonus"
import formatMediumFont from "@/shared/lib/format-medium-font"
import { selectCommunityInfo } from "@/entities/community"
import { toLocaleString } from "@/shared/lib/to-locale-string"

export const Balance = () => {
    const wallet = useAppSelector(selectTradingWallet)
    const bonuses = useAppSelector(selectBonuses)
    const community = useAppSelector(selectCommunityInfo)

    const currentBonus = useMemo(() => {
        if (community.type === 'foundation') {
            return bonuses.find(bonus => bonus.symbol.toLowerCase() === 'bon')
        }
        return bonuses.find(bonus => bonus.id === community.main_bonus)
    }, [bonuses, community])
    const balance = useMemo(() => wallet[currentBonus?.id]?.amount ?? 0, [wallet, currentBonus])

    return (
        <div className={'rounded-2xl screen:rounded-3xl transition-all ease-in bg-color-dark w-full px-4 py-5 screen:px-6 screen:py-7 flex justify-between items-center'}>
            <div className="flex items-center gap-3">
                <div className="w-[56px] h-[56px] relative shrink-0">
                    <div className="w-full h-full bg-white border border-[#E7EAEE] rounded-full overflow-hidden">
                        <img
                            className="w-full h-full object-contain"
                            src={currentBonus?.image}
                        />
                    </div>
                    <div className="rounded-full top-0 right-0 z-10 absolute bg-color-primary border border-[#E7EAEE] w-[25px] h-[15px] flex items-center justify-center">
                        <div className="text-white text-[7px] font-bold leading-[7px]">
                            соц
                        </div>
                    </div>
                </div>
                <div className={'text-color-base transition-all ease-in'}>
                    <div className='text-base text-white/70 leading-[16px] screen:text-lg screen:leading-[25px] mb-2 screen:mb-2'>Баланс</div>
                    <div className='text-2xl text-white font-mediumttf screen:text-[32px] leading-[24px] screen:leading-[32px] font-semibold'>
                        {formatMediumFont(toLocaleString(balance), 'text-3xl')}
                    </div>
                </div>
            </div>
            <EarnButton />
        </div>
    )
}